import { render, staticRenderFns } from "./SmsDelivery.vue?vue&type=template&id=78bc28bc&"
import script from "./SmsDelivery.vue?vue&type=script&lang=js&"
export * from "./SmsDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports